import React, { Component } from 'react'
import { connect } from 'react-redux'
import Moment from 'moment'
import * as R from 'ramda'

import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'

import { doc } from 'selectors/common'

import dataActions from 'actions/dataActions'
import sectionsActions from 'actions/sections'

let select = (state, props) => ({
	project: doc(state, props.projectID)
  , login: state.login
})

export class AddButton extends Component{
	render(){
		let { props } = this
		return(
			<div className="button">
				<span
					style={{
						cursor: "pointer"
					  , color: props.color || "#5ae4c3"
					}}
					onClick={()=> {
						let id = new Date().valueOf().toString()
						this.props.DOC_UPDATE({
							_id: id
						  , taskContent: ''
						  , projectID: props.project._id
						  , propertyID: props.project.propertyID
						  , accepted: ""
						  , priority: ""
						  , done : false
						  , status: "Open"
						  , urgent: ""
						  , note: ""
						  , schedule: {
								curStart: new Date()
							  , curDue: new Date(Moment(new Date()).add(1, 'days'))
							  , curDuration: 1
							  , curStrictStart: false
							  , curStrictDue: false
							}
						  , managerID : props.project.managerID
						  , dependencies : []
						  , comments: []
						  , type: "task"
						  , history:[{
								userID: props.login.userID
							  , auto: true, body: 'Create task'
							  , date: new Date().valueOf()
							  , value: ''
							}]
						})
						props.SECTION_EXPAND({section: "project/tasks", expanded:true})
					}}
				>
				   <svg
						width="18px"
						height="25px"
						viewBox="0 0 24 24"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						style={{
							verticalAlign: "middle"
						  , marginRight: "4px"
						  , marginTop: "-2px"
						}}
					>
						<title>Group 2</title>
						<defs></defs>
							<g id="Page-1" stroke={props.color || "#5ae4c3"} strokeWidth="2" fill="none" fillRule="evenodd">
								<g id="Group-2" transform="translate(1.000000, 1.000000)" stroke={props.color || "#5ae4c3"} strokeWidth="2">
								<path d="M11,4.5 L11,17.5" id="Line" strokeLinecap="square"></path>
								<path d="M5,11 L17,11" id="Line" strokeLinecap="square"></path>
								<circle id="Oval-1" cx="11" cy="11" r="11"></circle>
							</g>
						</g>
					</svg>
					<span style={{borderBottom: "dotted 2px " +  (props.color || "#5ae4c3")}}>NEW</span>
				</span>
			</div>
		)
	}
}
export default connect(select, R.mergeAll([dataActions, sectionsActions]))(AddButton)



// WEBPACK FOOTER //
// ./src/routes/landlord/projectForm/tasks/AddButton.js